import fetchClient from "api/axios";

export const getMaintenanceModeProperty = async () => {
  const response = await fetchClient.get(`/api/v1/properties/maintenance-mode`);
  return response.status === 200 && response?.data;
};
